import { useMyForm } from '../../../../../../react-commons/hooks/useMyForm';
import { ResourceType } from '../../../../resource/enumerations/ResourceType';
import { VCycleElementType } from '../../../../resource/enumerations/VCycleElementType';
import {
    defaultVCycleElementResource,
    useVCycleElementActions,
    VCycleElementMutationResourceSchema,
    VCycleElementParentRelation,
    type VCycleElementResource,
} from '../../../../resource/resources/artifacts/use_case/representation/vcycleElementResource';
import { EditChildBaseDialog } from '../../../reusable-components/dialogs/EditChildBaseDialog';
import { Form_DisplayComponentBaseView } from '../../../reusable-components/form-components/Form_DisplayComponentBaseView';
import { creationDialogOnSuccess } from '../../../util/utilFunctions';
import { VCycleElementContent } from './VCycleElementContent';

export const VCycleElementCreationDialog = ({
    onClose,
    parentId,
    projectId,
    projectVersionId,
    autoGeneratedProps,
    onCreated,
}: {
    onClose: () => void;
    parentId: string;
    projectId: string | undefined | null;
    projectVersionId: string | undefined | null;
    autoGeneratedProps?: VCycleElementResource;
    onCreated?: (id: string, objectId: string) => void;
}) => {
    const vcycleElementActions = useVCycleElementActions();
    const addVCycleElement = vcycleElementActions.useAddResource();

    const { form, formNames, onSubmit } = useMyForm({
        schema: VCycleElementMutationResourceSchema,
        defaultValues: {
            ...defaultVCycleElementResource,
            ...autoGeneratedProps,
        },
        submitHandler: async (data) => {
            const parentRelation =
                data.type === VCycleElementType.PROCESS_AREA ?
                    VCycleElementParentRelation.PROCESS_AREA_V_CYCLE_ELEMENT_CONTAINER
                :   VCycleElementParentRelation.V_CYCLE_REPRESENTATION_V_CYCLE_ELEMENT_CONTAINER;
            await addVCycleElement.mutateAsync(
                {
                    resource: data,
                    parentId,
                    parentRelation,
                },
                {
                    onSuccess: creationDialogOnSuccess(onCreated, onClose),
                }
            );
        },
    });

    return (
        <EditChildBaseDialog
            onClose={onClose}
            edited={form.formState.isDirty}
            title={'Create V-Cycle Element'}
            resourceType={ResourceType.V_CYCLE_ELEMENT}
        >
            <Form_DisplayComponentBaseView onSubmit={onSubmit} form={form} canSubmitDefaultValue={true}>
                <VCycleElementContent
                    projectId={projectId}
                    projectVersionId={projectVersionId}
                    form={form}
                    formNames={formNames}
                    readOnly={false}
                />
            </Form_DisplayComponentBaseView>
        </EditChildBaseDialog>
    );
};
